import { type CategoryTypes } from "~/models/category"
import type { PayrollType } from "~/models/payroll"
import type { PerformanceReviewType } from "~/models/performance-review"

export default {
	HomeUrl: () => "/",
	LoginUrl: () => "/auth",
	ContactUsUrl: () => "/contact-us",
	AboutUsUrl: () => "/about-us",
	RulesUrl: () => "/rules",
	// blog
	BlogUrl: () => `/blog`,
	BlogPageUrl: (page: number) => `/blog/page/${page}`,
	BlogCategoryUrl: (categoryId: number) => `/blog/category/${categoryId}`,
	BlogCategoryPageUrl: (categoryId: number, page: number) => `/blog/category/${categoryId}/page/${page}`,
	BlogArticleUrl: (articleId: number) => `/blog/single/${articleId}`,
	// company
	CompanyLoginUrl: (companyId: number) => `/company/${companyId}/auth`,
	CompanyDashboardUrl: () => `/company`,
	CompanyPayrollsUrl: (type: string) => `/company/payrolls/${type}`,
	CompanyPayrollsPageUrl: (type: string, page: number) => `/company/payrolls/${type}/page/${page}`,
	CompanyPerformanceReviewsUrl: (type: string) => `/company/performance-reviews/${type}`,
	CompanyPerformanceReviewsPageUrl: (type: string, page: number) =>
		`/company/performance-reviews/${type}/page/${page}`,
	CompanyCustomPageUrl: (customPageId: number) => `/company/custom-pages/${customPageId}`,
	CompanyCareersUrl: (companyId: number) => `/company/${companyId}/careers`,
	CompanyCareerUrl: (companyId: number, careerId: number) => `/company/${companyId}/careers/${careerId}`,
	// company projects
	CompanyProjectsUrl: () => `/company/projects`,
	CompanyProjectsPageUrl: (page: number) => `/company/projects/page/${page}`,
	CompanyProjectKanbanUrl: (projectId: number) => `/company/projects/${projectId}/kanban`,
	// company disciplinary notes
	CompanyDisciplinaryNotesUrl: () => `/company/disciplinary-notes`,
	// company announcements
	CompanyAnnouncementsUrl: () => `/company/announcements`,
	// panel attendances
	CompanyAttendancesUrl: () => `/company/attendances`,
	// panel
	PanelDashboardUrl: () => "/panel/dashboard",
	// panel payrolls
	PanelPayrollsUrl: (type: PayrollType) => `/panel/payrolls/${type}`,
	PanelPayrollsPageUrl: (type: string, page: any) => `/panel/payrolls/${type}/page/${page}`,
	PanelEditPayrollColumnsUrl: (type: string) => `/panel/payrolls/${type}/groups/columns`,
	PanelPayrollGroupsUrl: (type: string) => `/panel/payrolls/${type}/groups`,
	PanelPayrollGroupsPageUrl: (type: string, page: any) => `/panel/payrolls/${type}/groups/page/${page}`,
	// panel performance reviews
	PanelPerformanceReviewsUrl: (type: PerformanceReviewType) => `/panel/performance-reviews/${type}`,
	PanelPerformanceReviewsPageUrl: (type: string, page: any) => `/panel/performance-reviews/${type}/page/${page}`,
	PanelEditPerformanceReviewColumnsUrl: (type: string) => `/panel/performance-reviews/${type}/groups/columns`,
	PanelPerformanceReviewGroupsUrl: (type: string) => `/panel/performance-reviews/${type}/groups`,
	PanelPerformanceReviewGroupsPageUrl: (type: string, page: any) =>
		`/panel/performance-reviews/${type}/groups/page/${page}`,
	// panel careers
	PanelCareersUrl: () => `/panel/careers`,
	PanelCareerRequestsUrl: () => `/panel/careers/requests`,
	PanelCareerRequestsPageUrl: (page: any) => `/panel/careers/requests/page/${page}`,
	// panel projects
	PanelProjectsUrl: () => `/panel/projects`,
	PanelProjectsPageUrl: (page: number) => `/panel/projects/page/${page}`,
	PanelProjectKanbanUrl: (projectId: number) => `/panel/projects/${projectId}/kanban`,
	PanelPrivateProjectsUrl: () => `/panel/projects/private`,
	PanelPrivateProjectsPageUrl: (page: number) => `/panel/projects/private/page/${page}`,
	// panel attendances
	PanelAttendancesUrl: () => `/panel/attendances`,
	PanelAttendancesPageUrl: (page: number) => `/panel/attendances/page/${page}`,
	PanelUserAttendancesUrl: (userId: number) => `/panel/attendances/${userId}`,
	// panel custom pages
	PanelCustomPagesUrl: () => `/panel/custom-pages`,
	PanelCustomPagesPageUrl: (page: number) => `/panel/custom-pages/page/${page}`,
	PanelCustomPageUrl: (id: number) => `/panel/custom-pages/${id}`,
	// panel disciplinary notes
	PanelDisciplinaryNotesUrl: () => `/panel/disciplinary-notes`,
	PanelDisciplinaryNotesPageUrl: (page: number) => `/panel/disciplinary-notes/page/${page}`,
	PanelUserDisciplinaryNotesUrl: (id: number) => `/panel/disciplinary-notes/${id}`,
	// panel company settings
	PanelCompanySettingsUrl: () => `/panel/company-settings`,
	// panel announcements
	PanelAnnouncementsUrl: () => `/panel/announcements`,
	PanelAnnouncementsPageUrl: (page: number) => `/panel/announcements/page/${page}`,
	// panel organization chart
	PanelOrganizationChartUrl: () => `/panel/organization-chart`,
	// panel users
	PanelUsersUrl: () => `/panel/users`,
	PanelUsersPageUrl: (page: number) => `/panel/users/page/${page}`,
	PanelRolesUrl: () => `/panel/roles`,
	// panel categories
	PanelCategoriesUrl: () => `/panel/categories`,
	// admin
	AdminLoginUrl: () => "/admin/login",
	AdminDashboardUrl: () => "/admin",
	// admin users
	ManageUsersUrl: () => `/admin/users`,
	ManageUsersPageUrl: (page: number) => `/admin/users/page/${page}`,
	// admin logs
	ManageLogsUrl: () => `/admin/logs`,
	ManageLogsPageUrl: (page: number) => `/admin/logs/page/${page}`,
	// admin rules
	ManageRulesUrl: () => `/admin/rules`,
	// admin about us
	ManageAboutUsUrl: () => `/admin/about-us`,
	// admin contact us
	ManageContactUsUrl: () => `/admin/contact-us`,
	// admin metas
	ManageMetasUrl: () => `/admin/metas`,
	// admin slides
	ManageSlidesUrl: () => `/admin/slides`,
	// admin categories
	ManageCategoriesUrl: () => `/admin/categories`,
	// admin dev tickets
	ManageDevTicketUrl: (id: number) => `/admin/dev-tickets/${id}`,
	ManageDevTicketsUrl: () => `/admin/dev-tickets`,
	ManageDevTicketsPageUrl: (page: number) => `/admin/dev-tickets/page/${page}`,
	// admin posts
	ManagePostsUrl: (type: CategoryTypes) => `/admin/posts?type=${type}`,
	ManagePostsPageUrl: (type: CategoryTypes, page: any) => `/admin/posts/page/${page}?type=${type}`,
	AdminCreatePostUrl: (type: CategoryTypes) => `/admin/posts/create?type=${type}`,
	AdminEditPostUrl: (id: any) => `/admin/posts/${id}`
}
